import Cropper from 'cropperjs/dist/cropper.esm';
import 'cropperjs/dist/cropper.css'
import { WebClient } from '../webclient/webclient.service';
import * as $ from 'jquery';
import './image-cropper.less';



export class ImageCropperService {

    private popup;

    private imageUrl: string;
    private promise: { resolve, reject };
    private minWidthPixels;
    private minHeightPixels;
    private type: string = 'image/jpeg';
    private fname: string;
    private serverName;
    private saving = false;


    private cropper;

    private getCropper = (img, options) => {
        //return import(/*webpackChunkName: "cropper-lib"*/'cropperjs').then(Cropper => {
        return new Cropper(img, options);
        //});
    }

    constructor() {
        this.popup = $(this.popupTemplate);
        $('body').append(this.popup);
        this.initEvents();
        $(this.popup).on('hidden.bs.modal', () => {
            this.cropper.destroy();
            delete this.cropper;
            if (!this.saving) {
                this.promise.resolve(null);
            }
        });
    }

    private initEvents() {
        this.popup.on('click', 'a#cropper-rotate-left', () => this.cropper.rotate(-5));
        this.popup.on('click', 'a#cropper-rotate-right', () => this.cropper.rotate(5));
        this.popup.on('click', 'a#cropper-zoom-in', () => this.cropper.zoom(0.1));
        this.popup.on('click', 'a#cropper-zoom-out', () => this.cropper.zoom(-0.1));
        this.popup.on('click', 'a#cropper-flip', () => this.cropper.scaleX(this.scale *= -1));
        this.popup.on('click', '#cropper-done', () => this.saveImage());
    }

    private scale = 1;

    private saveImage = () => {
        this.saving = true;
        const data = this.cropper.getCroppedCanvas().toDataURL(this.type, 1.0);
        const promise = this.promise;
        WebClient.saveCroppedImage(this.fname, this.serverName, data)
            .then(result => {
                if (result.success)
                    promise.resolve({
                        serverPath: result.newImagePath,
                        image: data
                    })
                else {
                    console.warn(result.errorMessage);
                    promise.reject(result.errorMessage);
                }
                this.saving = false;

            })


    }


    private displayCroppedSize() {
        const data = this.cropper.getData();
        const div = $('#cropped-size');
        div.html(`Cropped size: <b>${data.width.toFixed()} X ${data.height.toFixed()}</b>`);
        if ((this.minWidthPixels && data.width < this.minWidthPixels) ||
            (this.minHeightPixels && data.height < this.minHeightPixels)) {
            div.addClass('error');
            $('#cropper-done').prop('disabled', true);
        }
        else {
            div.removeClass('error');
            $('#cropper-done').removeAttr('disabled');
        }

    }


    public popupCropper(imageUrl: string, ftype: string, fname: string, servername?: string, cropWidth?: number, cropHeight?: number) {

        this.imageUrl = imageUrl;
        this.minHeightPixels = cropHeight;
        this.minWidthPixels = cropWidth;
        this.type = ftype;
        this.fname = fname;
        this.serverName = servername;

        if (this.imageUrl.length == 0) return null;
        $('.cropper-root').html('').append($('<img />').attr('src', imageUrl)).hide();
        $('.cropper-toolbar').hide();
        $('.mce-floatpanel').css('z-index', 1040);
        $(this.popup).modal('show');

        setTimeout(() => {
            if (this.cropper)
                return;
            let img = $('.cropper-root').find('img')[0];

            let options = {
                preview: '.cropper-preview'
            };
            if (!!cropWidth && !!cropHeight) {
                (options as any).autoCropArea = 1;
                (options as any).dragMode = 'move';
                (options as any).viewMode = 1;
                (options as any).aspectRatio = cropWidth / cropHeight;
                (options as any).autoCropArea = 1;
                (options as any).cropBoxResizable = false;
            }
            //this.getCropper(img, options).then(cropper => {
            this.cropper = this.getCropper(img, options);
            img.addEventListener('zoom', (event) => {
                this.displayCroppedSize();
            });
            setTimeout(() => {
                $('.cropper-root').closest('.col-xl-10').height(this.cropper.getContainerData().height + 20);
                this.displayCroppedSize();
                // $('.cropper-toolbar').fadeIn();
            }, 1000);
            $('.cropper-root, .cropper-toolbar').fadeIn();

            //});


            //$('.cropper-toolbar').css('opacity', 1);
            //$('.cropper-root').html('').append(img).hide();
        }, 1000)


        return new Promise<{ image: string, serverPath: string }>((resolve, reject) => {
            this.promise = { resolve: resolve, reject: reject }
        })


    }

    // private showPreview() {
    //     let crData = this.cropper.getCropBoxData();
    //     let imgData = this.cropper.getImageData();
    //     console.log(imgData);
    //     let caData = this.cropper.getCanvasData();
    //     let width = imgData.width;
    //     let height = imgData.height;
    //     let top = Math.max(crData.top - caData.top, 0);
    //     let left = Math.max(crData.left - caData.left, 0);
    //     let pwidth = $('.cropper-preview').parent().width();
    //     let ratio = Math.min(pwidth / crData.width * imgData.scaleX, 1);
    //     $('.cropper-preview').find('img').width(width * ratio)
    //         .height(ratio * height)
    //         .css({ top: -ratio * top, left: -ratio * left, transform: `rotate(${imgData.rotate}deg)` });
    //     $('.cropper-preview').height(ratio * crData.height);
    //     $('.cropper-preview').width(ratio * crData.width);
    // }

    // private sizeCropper() {
    //     var img = new Image();
    //     img.src = dataURL; //dataURL is a base64 image data code previusly obtained.
    //     img.onload = function(){
    //     }
    // }


    private popupTemplate = `
            <div  class="modal fade cropper-popup">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <label class="editor-title">Crop/Edit Image</label>
							<button type="button" class="close" data-dismiss="modal"><span class="mdi mdi-close"></span></button>
                        </div>
                        <div class="modal-body">
                            <div class="editor-content">
                                <div class="row">
                                    <div class="col-xl-10">
                                        <div class="cropper-root"></div>
                                    </div>
                                    <div class="col-xl-2 cropper-toolbar">
                                        <div class="cropper-preview"></div>
                                        <div class="cropper-icons">
                                        <a id="cropper-zoom-out"><i class="material-icons">zoom_out</i></a>
                                        <a id="cropper-zoom-in"><i class="material-icons">zoom_in</i></a>
                                        <a id="cropper-flip"><i class="material-icons">flip</i></a>
                                        <a id="cropper-rotate-left"><i class="material-icons">rotate_left</i></a>
                                        <a id="cropper-rotate-right"><i class="material-icons">rotate_right</i></a>
                                        </div>
                                        <div id="cropped-size"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
							<button  type="button" class="button type-5 toRight" data-dismiss="modal">Cancel</button>
                            <button id="cropper-done" type="button" class="button type-2 toRight" data-dismiss="modal">Done</button>
                        </div>
                    </div>
                </div>
            </div>`


}
